import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SOLUTION_STATUS } from '../constants/solution-status.enum';
import { INCIDENCE_RESOLUTIONS_LIST_KEY, INCIDENCE_RESOLUTIONS_ONE_KEY } from '../constants';
import { IncidenceResolutionService } from '../services';

const useUpdateRefundStatus = (id: string) => {
  const { t } = useTranslation('incidence');
  const queryClient = useQueryClient();

  const { mutate, isPending: isLoading } = useMutation(
    (status: SOLUTION_STATUS) => IncidenceResolutionService.updateStatus(id, status),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [INCIDENCE_RESOLUTIONS_LIST_KEY] });
        queryClient.invalidateQueries({ queryKey: [id, INCIDENCE_RESOLUTIONS_ONE_KEY] });
        toast.success(t('successUpdate'));
      },
      onError: () => {
        toast.error(t('generalErrorMessage', { ns: 'errors' }));
      },
    },
  );

  return {
    updateStatus: mutate,
    isLoading,
  };
};

export default useUpdateRefundStatus;
